/** Теги кешу, які інвалідовує зміна зв'язку: зв'язки типів (Links/LIST), а також зв'язки й історія кожного відомого кінця (бекенд пише історію обом записам). */
export function linkTags(recordId: string, otherId?: string) {
  const ends = otherId && otherId !== recordId ? [recordId, otherId] : [recordId];
  return [{ type: 'Links' as const, id: 'LIST' }, ...ends.flatMap((id) => [{ type: 'Links' as const, id }, { type: 'History' as const, id }])];
}
